import AppStateSlice from "../../models/AppStateSlice";

import PWAStateSlice from "../../models/state/pwa/PWAStateSlice";

export function getPWAStateSlice(state: AppStateSlice): PWAStateSlice {
  return state.pwa;
}
